<template>
  <section class="hero is-fullheight">
    <div class="hero-body">

      <div class="container has-text-centered">
        <h1>Huy's Page</h1>
      </div>

    </div>
  </section>
</template>

<script>

console.log('hello, HuyPage')

export default {
  name: 'HuyPage'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/huy/HuyPage.vue